import { FC, HTMLAttributes } from 'react';
import { ReactComponent as Sort } from '../assets/sort.svg';
import { ReactComponent as SortDown } from '../assets/sort-dawn.svg';
import { ReactComponent as SortUp } from '../assets/sort-up.svg';
import { SortStateType } from '../../types';
import { SortTypes } from 'Src/Types/Preset';
import cn from 'classnames';
import st from './SortBtn.module.scss';

interface ISortButtonProps extends HTMLAttributes<HTMLButtonElement> {
	/** ИД колонки */
	columnId: string;
	/** Состояние сортировки */
	state?: SortStateType;
	/** НЕ доступность сортировки */
	disabled?: boolean;
	/** Скрывать не активные */
	hiddenWhenNotActive?: boolean;
	/** Функция изменения состояния сортировки */
	onSortChange?: (newState: SortStateType) => void;
}

/** Компонента кнопки-сортировки таблицы */
const SortButton: FC<ISortButtonProps> = (props) => {
	const {
		columnId,
		state,
		onSortChange,
		hiddenWhenNotActive = true,
		disabled = false,
		className,
		...otherProps
	} = props;

	/** Вычисление следующего состояния и отправка его в таблицу */
	const onSortChangeHandler = () => {
		if (!onSortChange) {
			return;
		}
		const newSate = {
			columnId,
			type: getNextSortDir(),
		};
		onSortChange(newSate);
	};

	/** Вычисляет следующие состояние сортировки  */
	const getNextSortDir = (): SortTypes => {
		if (state?.columnId !== columnId) {
			return 'ASC';
		} else if (!state.type) {
			return 'ASC';
		} else if (state.type === 'ASC') {
			return 'DESC';
		} else if (state.type === 'DESC') {
			return 'ASC';
		}
		// else if ( state === "DESC" )
		// 	return undefined;
	};

	/** Нужно ли отобразить кнопку */
	const checkVisible = () => {
		if (!hiddenWhenNotActive) {
			return true;
		} else if (disabled) {
			return false;
		} else if (!state) {
			return false;
		} else if (state.columnId !== columnId) {
			return false;
		} else if (state.columnId === columnId && !!state.type) {
			return true;
		}
	};

	/** Отрисовка иконки сортировки взависимости от состояния */
	const renderIcon = () => {
		if (state) {
			if (state.columnId !== columnId) {
				return <Sort />;
			} else if (state.type === 'ASC') {
				return <SortUp />;
			} else if (state.type === 'DESC') {
				return <SortDown />;
			}
		} else {
			return <Sort />;
		}
	};

	/** Отрисовка кнопки сортировки */
	const renderBtn = () => {
		return (
			<button
				id={'btn_sort-' + columnId}
				className={cn(st.btn, className, {
					[st.unvisible]: !checkVisible(),
				})}
				disabled={disabled}
				onClick={onSortChangeHandler}
				{...otherProps}
			>
				{renderIcon()}
			</button>
		);
	};

	const renderEmpty = () => {
		return <span id={'btn_sort-' + columnId} className={st.empty} />;
	};

	return disabled ? renderEmpty() : renderBtn();
};

export default SortButton;
